// src/config/permissions.js

// ============================================
// RÔLES
// ============================================
export const ROLES = {
    ADMIN: 'admin',
    GESTIONNAIRE: 'gestionnaire',
    COMMERCIAL: 'commercial',
    MAGASINIER: 'magasinier',
    AUTRES: 'autres'
};

export const ROLE_LABELS = {
    [ROLES.ADMIN]:        'Administrateur',
    [ROLES.GESTIONNAIRE]: 'Gestionnaire',
    [ROLES.COMMERCIAL]:   'Commercial',
    [ROLES.MAGASINIER]:   'Magasinier',
    [ROLES.AUTRES]:       'Autres'
};

export const ROLE_COLORS = {
    [ROLES.ADMIN]:        'danger',
    [ROLES.GESTIONNAIRE]: 'warning',
    [ROLES.COMMERCIAL]:   'info',
    [ROLES.MAGASINIER]:   'success',
    [ROLES.AUTRES]:       'secondary'
};

// ============================================
// MODULES
// ============================================
export const MODULES = {
    DASHBOARD: 'dashboard',
    CLIENTS: 'clients',
    FOURNISSEURS: 'fournisseurs',
    PRODUITS: 'produits',
    STOCK: 'stock',
    VENTES: 'ventes',
    ACHATS: 'achats',
    LOGISTIQUE: 'logistique',   // ← NOUVEAU
    STATISTIQUES: 'statistiques',
    PARAMETRES: 'parametres',
    UTILISATEURS: 'utilisateurs',
    SCANNER: 'scanner'
};

// ============================================
// MATRICE DES PERMISSIONS
// ============================================
export const ROLE_PERMISSIONS = {
    // ===== ADMIN - Accès à TOUT =====
    [ROLES.ADMIN]: {
        [MODULES.DASHBOARD]:    ['view'],
        [MODULES.CLIENTS]:      ['view', 'create', 'edit', 'delete', 'import'],
        [MODULES.FOURNISSEURS]: ['view', 'create', 'edit', 'delete'],
        [MODULES.PRODUITS]:     ['view', 'create', 'edit', 'delete', 'import'],
        [MODULES.STOCK]:        ['view', 'edit', 'inventory', 'traceability'],
        [MODULES.VENTES]:       ['view', 'create', 'edit', 'delete', 'invoice', 'proforma', 'bl', 'payment'],
        [MODULES.ACHATS]:       ['view', 'create', 'edit', 'delete', 'order', 'reception'],
        [MODULES.LOGISTIQUE]:   ['view', 'create', 'edit', 'delete'],
        [MODULES.STATISTIQUES]: ['view', 'export'],
        [MODULES.PARAMETRES]:   ['view', 'edit'],
        [MODULES.UTILISATEURS]: ['view', 'create', 'edit', 'delete'],
        [MODULES.SCANNER]:      ['view', 'scan']
    },

    // ===== GESTIONNAIRE =====
    [ROLES.GESTIONNAIRE]: {
        [MODULES.DASHBOARD]:    ['view'],
        [MODULES.CLIENTS]:      ['view', 'create', 'edit', 'import'],
        [MODULES.FOURNISSEURS]: ['view', 'create', 'edit'],
        [MODULES.PRODUITS]:     ['view', 'create', 'edit', 'import'],
        [MODULES.STOCK]:        ['view', 'edit', 'inventory', 'traceability'],
        [MODULES.VENTES]:       ['view', 'create', 'edit', 'invoice', 'proforma', 'bl', 'payment'],
        [MODULES.ACHATS]:       ['view', 'create', 'edit', 'order', 'reception'],
        [MODULES.LOGISTIQUE]:   ['view', 'create', 'edit'],
        [MODULES.STATISTIQUES]: ['view', 'export'],
        [MODULES.PARAMETRES]:   ['view'],
        [MODULES.SCANNER]:      ['view', 'scan']
    },

    // ===== COMMERCIAL =====
    [ROLES.COMMERCIAL]: {
        [MODULES.DASHBOARD]:    ['view'],
        [MODULES.CLIENTS]:      ['view', 'create', 'edit'],
        [MODULES.FOURNISSEURS]: ['view'],
        [MODULES.PRODUITS]:     ['view'],
        [MODULES.STOCK]:        ['view'],
        [MODULES.VENTES]:       ['view', 'create', 'edit', 'invoice', 'proforma', 'bl', 'payment'],
        [MODULES.STATISTIQUES]: ['view'],
        [MODULES.SCANNER]:      ['view', 'scan']
    },

    // ===== MAGASINIER =====
    [ROLES.MAGASINIER]: {
        [MODULES.DASHBOARD]:    ['view'],
        [MODULES.PRODUITS]:     ['view'],
        [MODULES.STOCK]:        ['view', 'edit', 'inventory', 'traceability'],
        [MODULES.SCANNER]:      ['view', 'scan']
    },

    // ===== AUTRES - Tableau de bord + Logistique + Fournisseurs =====
    [ROLES.AUTRES]: {
        [MODULES.DASHBOARD]:    ['view'],
        [MODULES.LOGISTIQUE]:   ['view', 'create', 'edit'],
        [MODULES.FOURNISSEURS]: ['view']
    }
};

// ============================================
// CONFIGURATION DES ROUTES
// ============================================
export const MENU_PERMISSIONS = {
    // Dashboard
    '/dashboard/finance':          { module: MODULES.DASHBOARD,    permission: 'view' },
    '/dashboard/ca':               { module: MODULES.DASHBOARD,    permission: 'view' },
    '/dashboard/ventes-jour':      { module: MODULES.DASHBOARD,    permission: 'view' },
    '/dashboard/stock-critique':   { module: MODULES.STOCK,        permission: 'view' },
    '/dashboard/commandes':        { module: MODULES.ACHATS,       permission: 'view' },
    '/dashboard/impayes':          { module: MODULES.VENTES,       permission: 'view' },

    // Clients
    '/ventes/clients/liste':       { module: MODULES.CLIENTS,      permission: 'view' },
    '/ventes/clients/ajouter':     { module: MODULES.CLIENTS,      permission: 'create' },
    '/ventes/clients/modifier/:id':{ module: MODULES.CLIENTS,      permission: 'edit' },
    '/ventes/clientsDetails/:id':  { module: MODULES.CLIENTS,      permission: 'view' },
    '/ventes/clients/import':      { module: MODULES.CLIENTS,      permission: 'import' },

    // Factures
    '/ventes/factures/nouveau':    { module: MODULES.VENTES,       permission: 'invoice' },
    '/ventes/factures/liste':      { module: MODULES.VENTES,       permission: 'view' },
    '/ventes/factures/impayees':   { module: MODULES.VENTES,       permission: 'view' },
    '/ventes/avoirs':              { module: MODULES.VENTES,       permission: 'view' },
    '/ventes/facturesDetails/:id': { module: MODULES.VENTES,       permission: 'view' },

    // Devis
    '/ventes/devis/nouveau':       { module: MODULES.VENTES,       permission: 'proforma' },
    '/ventes/devisListe':          { module: MODULES.VENTES,       permission: 'view' },
    '/ventes/devis/acceptes':      { module: MODULES.VENTES,       permission: 'view' },
    '/ventes/DetailDevis/:id':     { module: MODULES.VENTES,       permission: 'view' },
    '/ventes/devis/modifier/:id':  { module: MODULES.VENTES,       permission: 'edit' },
    '/ventes/devis/envoyer/:id':   { module: MODULES.VENTES,       permission: 'view' },

    // Bons de livraison
    '/ventes/bl/nouveau':          { module: MODULES.VENTES,       permission: 'bl' },
    '/ventes/blListe':             { module: MODULES.VENTES,       permission: 'view' },
    '/ventes/bl/en-cours':         { module: MODULES.VENTES,       permission: 'view' },
    '/ventes/blDetails/:id':       { module: MODULES.VENTES,       permission: 'view' },
    '/ventes/bl/modifier/:id':     { module: MODULES.VENTES,       permission: 'edit' },

    // Règlements
    '/ventes/NouveauReglement':    { module: MODULES.VENTES,       permission: 'payment' },
    '/ventes/reglements':          { module: MODULES.VENTES,       permission: 'view' },
    '/ventes/reglementsEcheancier':{ module: MODULES.VENTES,       permission: 'view' },
    '/ventes/reglements/:id':      { module: MODULES.VENTES,       permission: 'view' },

    // Fournisseurs
    '/achats/fournisseurs':             { module: MODULES.FOURNISSEURS, permission: 'view' },
    '/achats/fournisseursAjouter':      { module: MODULES.FOURNISSEURS, permission: 'create' },
    '/achats/fournisseurs/modifier/:id':{ module: MODULES.FOURNISSEURS, permission: 'edit' },
    '/achats/fournisseurs/:id':         { module: MODULES.FOURNISSEURS, permission: 'view' },
    '/achats/fournisseursEvaluation':   { module: MODULES.FOURNISSEURS, permission: 'view' },

    // Commandes
    '/achats/commandesNouveau':       { module: MODULES.ACHATS,    permission: 'order' },
    '/achats/commandes':              { module: MODULES.ACHATS,    permission: 'view' },
    '/achats/commandesCours':         { module: MODULES.ACHATS,    permission: 'view' },
    '/achats/commandesRecues':        { module: MODULES.ACHATS,    permission: 'view' },
    '/achats/commandesHistorique':    { module: MODULES.ACHATS,    permission: 'view' },
    '/achats/commandes/:id':          { module: MODULES.ACHATS,    permission: 'view' },
    '/achats/commandesModifier/:id':  { module: MODULES.ACHATS,    permission: 'edit' },

    // Produits
    '/stock/produits':                { module: MODULES.PRODUITS,  permission: 'view' },
    '/stock/produitsAjouter':         { module: MODULES.PRODUITS,  permission: 'create' },
    '/stock/produitsCategories':      { module: MODULES.PRODUITS,  permission: 'view' },
    '/stock/produits/import':         { module: MODULES.PRODUITS,  permission: 'import' },
    '/stock/produits/:id':            { module: MODULES.PRODUITS,  permission: 'view' },
    '/stock/produits/modifier/:id':   { module: MODULES.PRODUITS,  permission: 'edit' },
    '/stock/mouvements/ajouter/:id':  { module: MODULES.PRODUITS,  permission: 'edit' },

    // Prêts
    '/stock/prets':                   { module: MODULES.STOCK,     permission: 'view' },
    '/stock/prets/ajouter':           { module: MODULES.STOCK,     permission: 'edit' },
    '/stock/prets/articles':          { module: MODULES.STOCK,     permission: 'view' },

    // État du stock
    '/stock/etat/instantane':         { module: MODULES.STOCK,     permission: 'view' },
    '/stock/etat/mouvements':         { module: MODULES.STOCK,     permission: 'traceability' },
    '/stock/etat/valeur':             { module: MODULES.STOCK,     permission: 'view' },
    '/stock/etat/critique':           { module: MODULES.STOCK,     permission: 'view' },

    // Scanner
    '/stock/scanner':                 { module: MODULES.SCANNER,   permission: 'scan' },

    // Inventaire
    '/stock/inventaire':              { module: MODULES.STOCK,     permission: 'inventory' },
    '/stock/inventaire/nouveau':      { module: MODULES.STOCK,     permission: 'inventory' },
    '/stock/inventaire/:id':          { module: MODULES.STOCK,     permission: 'view' },

    // Traçabilité
    '/stock/tracabilite':             { module: MODULES.STOCK,     permission: 'traceability' },

    // ===== LOGISTIQUE =====
    '/logistique/vehicules':              { module: MODULES.LOGISTIQUE, permission: 'view' },
    '/logistique/vehicules/ajouter':      { module: MODULES.LOGISTIQUE, permission: 'create' },
    '/logistique/vehicules/modifier/:id': { module: MODULES.LOGISTIQUE, permission: 'edit' },
    '/logistique/missions':               { module: MODULES.LOGISTIQUE, permission: 'view' },

    // Statistiques
    '/stats/dashboard':               { module: MODULES.STATISTIQUES, permission: 'view' },
    '/stats/ventes/ca':               { module: MODULES.STATISTIQUES, permission: 'view' },
    '/stats/ventes/mensuel':          { module: MODULES.STATISTIQUES, permission: 'view' },
    '/stats/ventes/top-produits':     { module: MODULES.STATISTIQUES, permission: 'view' },
    '/stats/ventes/top-clients':      { module: MODULES.STATISTIQUES, permission: 'view' },
    '/stats/achats/depenses':         { module: MODULES.STATISTIQUES, permission: 'view' },
    '/stats/achats/fournisseurs':     { module: MODULES.STATISTIQUES, permission: 'view' },
    '/stats/stock/rotation':          { module: MODULES.STATISTIQUES, permission: 'view' },
    '/stats/finances/tresorerie':     { module: MODULES.STATISTIQUES, permission: 'view' },
    '/stats/finances/encours':        { module: MODULES.STATISTIQUES, permission: 'view' },

    // Paramètres société
    '/parametres/societe/infos':      { module: MODULES.PARAMETRES, permission: 'view' },
    '/parametres/societe/taxes':      { module: MODULES.PARAMETRES, permission: 'view' },

    // Utilisateurs
    '/parametres/utilisateurs':              { module: MODULES.UTILISATEURS, permission: 'view' },
    '/parametres/utilisateurs/nouveau':      { module: MODULES.UTILISATEURS, permission: 'create' },
    '/parametres/utilisateursRoles':         { module: MODULES.UTILISATEURS, permission: 'view' },

    // Sauvegarde
    '/parametres/sauvegarde/manuel':         { module: MODULES.PARAMETRES, permission: 'edit' },
    '/parametres/sauvegarde/restauration':   { module: MODULES.PARAMETRES, permission: 'edit' },

    // Pages diverses
    '/pages/profile':         { module: MODULES.UTILISATEURS, permission: 'view' },
    '/pages/edit-profile':    { module: MODULES.UTILISATEURS, permission: 'edit' },
    '/pages/aide':            { module: MODULES.DASHBOARD,    permission: 'view' },
    '/pages/settings':        { module: MODULES.UTILISATEURS, permission: 'edit' }
};